//
// index.js - main import file (put application code in application.js)
// ------------------------------------------------------------------// 


// Import Booststrap components as needed
import { Util, DropDown, Alert, Collapse, Toast, Modal, Offcanvas } from 'bootstrap';

// Import jQUery Validation components as needed
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';

import svg4everybody from 'svg4everybody';

svg4everybody({
    nosvg: true,
    polyfill: true
});

// Import application code
import './Application';
import './Shame';